// extracted by mini-css-extract-plugin
module.exports =  {"veryPayWidget":"pl__VeryPayWidgetContainer-module__veryPayWidget___g6tVw","contentTileItem":"pl__VeryPayWidgetContainer-module__contentTileItem___YmhIq"};